   function toggleArrows(rowElement) {
        let arrowIndicator = rowElement.querySelector('svg')

         if (arrowIndicator) {
              arrowIndicator.classList.toggle('open')
        }
  }



  let mainMobileRows = document.querySelectorAll('.mobile-menu__main-item .main-row');
  let mainMenuItems = document.querySelectorAll('.main-menu-item');
  let subMenuItems = document.querySelectorAll('.sub-menu-item');
  let subMenuRows = document.querySelectorAll('.mobile-menu__main-item .submenu-row');
  let grandMenu = document.querySelectorAll('.grand-submenu');
  let subMenus = document.querySelectorAll('.submenu-data');


  subMenuRows.forEach((row, index) => {
    console.log('clicked')
                row.onclick = function (e) {
              
                let container = subMenuItems[index];
                let menuDropdown = grandMenu[index];            
                if (menuDropdown &&  e.target.closest('.link-item') == null) {
                     let height = menuDropdown.clientHeight + row.clientHeight;
                      let mainParent = row.parentNode.parentNode;
                      let parentIndex = Array.from(subMenus).indexOf(mainParent);
                

                  if (container.classList.contains('details-open')) {
                      container.removeAttribute('style');
                  } else {
                      container.style.height = `${height}px`
                  }

                  toggleArrows(row)

                 setTimeout(() => {
                           let totalHeight = subMenus[parentIndex].clientHeight + mainMobileRows[parentIndex].clientHeight;
                            mainMenuItems[parentIndex].style.height = `${totalHeight}px`
                        }, 250)

                  container.classList.toggle('details-open')
                 
                }
                

                }
               })

  mainMobileRows.forEach((row, index) => {
    // index ++;
    row.addEventListener('click', function (e) {
      console.log({ target: e.target.closest('.link-item') });
      let submenu = document.querySelectorAll('.mobile-menu__main-item .submenu-data')[index];
      console.log(index);
      console.log(submenu);
            let triggerElement = this;
            let container = mainMenuItems;
            let containerIndex = index

               
      
                if (submenu && e.target.closest('.link-item') == null) {
               //   submenu.classList.toggle('closed-menu')

                if (container[containerIndex].classList.contains('options-open')) {
                  container[containerIndex].removeAttribute('style')
                let subItems = container[containerIndex].querySelectorAll('.sub-menu-item');

                clearSubMenuItemState(subItems)
                  
                } else {                  
                  container.forEach(item => {
                    item.removeAttribute('style');
                    item.classList.remove('options-open');
                    item.querySelector('svg.icon.icon-caret').classList.remove('open');
                    clearSubMenuItemState(item.querySelectorAll('.sub-menu-item'))
                  })
                  let menuHeight = triggerElement.clientHeight + submenu.clientHeight;
                  container[containerIndex].style.height = `${menuHeight}px`
                }

                  container[containerIndex].classList.toggle('options-open')

                   let subMenuHeight =  submenu.clientHeight;
                //  console.log({ subMenuHeight })

                 toggleArrows(this)
                }

    
    })
  })

function clearSubMenuItemState(subItems) {
  
                  if (subItems.length > 0) {
                    subItems.forEach(item => {
                      item.removeAttribute('style');
                      item.classList.remove('details-open');

                      let arrow = item.querySelector('svg');

                      if (arrow) {
                        arrow.classList.remove('open')
                      }
                    })
                  }
}